export default "__VITE_ASSET__vBeKXAM3__"